
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-df323ca6&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CategoryView.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CategoryView.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-df323ca6!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CategoryView.vue"),
  /* scopeId */
  "data-v-df323ca6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/views/CategoryView.vue
// module id = ./dev/src/views/CategoryView.vue
// module chunks = 0